<svg width="24" height="24" fill="none" stroke="#16151C" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <g stroke-width="1.5">
  <g stroke-linecap="round" stroke-linejoin="round">
   <path d="m3 6h7"/>
   <path d="m3 12h9"/>
   <path d="m19 12h2"/>
   <path d="m14 6h7"/>
   <path d="m13 18h7"/>
   <path d="m3 18h3"/>
  </g>
  <circle cx="8" cy="18" r="2"/>
  <circle cx="17" cy="12" r="2"/>
  <circle cx="12" cy="6" r="2"/>
 </g>
</svg>
